// import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Home() {
    return (
        <div className="App" id='home'>
            <Header />
          
          <div className='mt-3 my-16 group-container'>
              <div className='maincontainer py-8'>
                  <div className='flex flex-col md:flex-row'>
                      <div className='w-full md:w-2/5 justify-center text-center'>
                          <img className='w-1/2 md:w-full h-auto' src='./assets/img/pagina.png' alt='Imagen Facturacion'/>
                      </div>
                      <div className='w-full px-4 md:w-3/5 md:p-4 md:pl-16'>
                          <div className='text-3xl md:text-6xl text-standardGray font-Roboto font-bold '>Facturaci&oacute;n Electr&oacute;nica</div>
                          <div className='text-xl text-red-500 font-bold mt-4 md:mt-8'>Sistema ERP</div>
                          <div className='mt-4'>
                              <p className='text-justify'>Contamos con un Sistema ERP integrado y autorizado por la DGII para la emisi&oacute;n y recepci&oacute;n de comprobantes electr&oacute;nicos.</p>
                          </div>
  
                          <div className='text-xl text-red-500 font-bold mt-4 md:mt-8'>API e integraci&oacute;n para desarrolladores</div>
                          <div id='services' className='mt-4'>
                              <p className='text-justify'>Contamos con una API REST y sistemas de bases de datos para integrar sistemas de otros desarrolladores y de esta manera permitir la generaci&oacute;n de comprobantes electr&oacute;nicos.</p>
                          </div>
                      </div>
                  </div>
              </div>
              {/* <div style={{marginTop: 40}}>
                  <h1 className='text-2xl font-bold' style={{textAlign: "center", marginBottom: 0}}>Pagina en <span style={{color: "red"}}>Desarrollo.</span></h1>
                  <h3 className='font-bold' style={{textAlign: "center", marginTop: 0 }}>En desarrollo.... </h3>
              </div>
              <div style={{display: "flex", width: "100%", justifyContent: "center"}}>
                  <img style={{height: "auto", width: "80vh;"}} src="./assets/img/logoSistema.png" alt='Banner'/>
              </div> */}
          </div>
          <div className='group-container bg-gray-100 text-standardGray'>
              <div className='maincontainer px-4 md:px-0'>
                  <div className='justify-center text-center my-8 md:my-16'>
                      <div>
                          <div className='text-3xl md:text-5xl text-standardGray font-bold'>Servicios</div>
                          <div className='mt-2 text-center text-standardGray'>Dentro de nuestra infraestructura para el manejo de la facturacion electronica contamos con los siguientes servicios.</div>
                      </div>
                      <div className='grid grid-cols-1 md:grid-cols-3 mt-8 gap-8'>
                          <div className='min-h-[200px] bg-white p-10 w-full border-8' style={{ borderRadius: '10px' }}>
                              {/* <div><img src="./assets/img/01.webp" alt="img1" /></div> */}
                              <div><img src="./assets/img/erp.png" className='w-[130px] h-[116px]' alt="img1" /></div>
                              <div className='mt-2 font-bold text-xl text-standardGray'>Sistema ERP</div>
                              <div className='mt-2 text-standardGray text-justify'>Contamos con un completo Sistema ERP para el control completo de los procesos de su empresa integrado y autorizado por la DGII para la emisi&oacute;n y recepci&oacute;n de comprobantes electr&oacute;nicos.</div>
                          </div>
                          <div className='min-h-[200px] bg-white p-10 w-full border-8' style={{ borderRadius: '10px' }}>
                              {/* <div><img src="./assets/img/02.webp" alt="img1" /></div> */}
                              <div><img src="./assets/img/api.png" className='w-[130px] h-[116px]' alt="img1" /></div>
                              <div className='mt-2 font-bold text-xl text-standardGray'>API REST</div>
                              <div className='mt-2 text-standardGray text-justify'>Desarrollamos una API WEB para poder integrar con sistemas externos donde las empresas pueden enviar sus XML y estos ser firmados y enviados a DGII.</div>
                          </div>
                          <div id='contact' className='min-h-[200px] bg-white p-10 w-full border-8' style={{ borderRadius: '10px' }}>
                              {/* <div><img src="./assets/img/03.webp" alt="img1" /></div> */}
                              <div><img src="./assets/img/database.png" className='w-[130px] h-[116px]' alt="img1" /></div>
                              <div className='mt-2 font-bold text-xl text-standardGray'>Integraci&oacute;n con base de datos</div>
                              <div className='mt-2 text-standardGray text-justify'>Mediante esta herramienta, empresas externas pueden conectarse a motores de base de datos en la nube y almacenar la informaci&oacute;n que ser&aacute; enviada de manera electr&oacute;nica a DGII sin tener que complicarse con la estructura de los XML.</div>
                          </div>  
                      </div>
                  </div>
              </div>
          </div>
          <div className='group-container bg-white text-standardGray'>
              <div className='maincontainer'>
                  <div className='justify-center text-center my-16'>
                      <div className=''>
                          <div className='text-3xl md:text-5xl text-standardGray font-bold'>Contacto</div>
                      </div>
                      <div className='grid grid-cols-1 md:grid-cols-2 mt-8 md:gap-16'>
                          <div className='md:px-4'>
                              <iframe className='w-4/5 md:w-full' title='map'
                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.8654986951783!2d-70.6823552890123!3d19.46136498174839!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eb1c585e86ced3f%3A0x2343f1bf41eca264!2sRacol%20Computers%2C%20SRL.!5e0!3m2!1ses!2sdo!4v1718496527514!5m2!1ses!2sdo" 
                                    height="450" 
                                  style={{ border: 0 }}
                                  referrerPolicy="no-referrer-when-downgrade"
                                  loading="lazy" 
                                  >
                              </iframe>
                          </div>
                          <div className='text-left px-8 md:px-0'>
                              {/* <p className='font-bold text-standardGray text-2xl m-0'>Direccion:</p> */}
                              <p className='text-lg md:mt-0 text-standardGray font-Roboto px-4' style={{lineHeight: '2.5'}}>
                                  <span className='font-bold'>Racol Computers, S.R.L.</span><br/>
                                  Av. 27 de Febrero #37, Villa Progreso<br/>
                                  Santiago, Rep&uacute;blica Dominicana<br/>
                                  <span className='font-bold'>Correo:&nbsp;</span>servicios@racolcomputers.com<br/>
                                  <span className='font-bold'>Tel&eacute;fono:&nbsp;</span>(809)-971-3157<br/>
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <Footer />
        </div>
    );
  }
  
  export default Home;
